import axios from "axios";
import Config from "./Config";
import { toast } from "sonner"; 

const { API_BASE_URL } = Config;
const headers = {
  "Content-Type": "application/json",
};

// ---------------------------Contact ------------------------
// =========================Get All Contact=========================
export const AddContact = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/contact-us`, data, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message); // Toast success message
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};

export const getAllState = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/state`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data.responsedata;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching state data:",
      error.response || error.message || error
    );
    throw error;
  }
};
export const getAllCountry = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/country`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data.responsedata;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching state data:",
      error.response || error.message || error
    );
    throw error;
  }
};

export const getAllStateCountryId = async (Id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/state/${Id}`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data.responsedata;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching state data:",
      error.response || error.message || error
    );
    throw error;
  }
};

export const getAllCityByStateId = async (Id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/city/${Id}`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data.responsedata;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching state data:",
      error.response || error.message || error
    );
    throw error;
  }
};

export const AddInquiry = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/inquiry`, data, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message); // Toast success message
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};


export const AddAgencyInq = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/agency-inquiry`, data, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message); // Toast success message
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};
export const AddSellerInq = async (data) => {
  try {
    const response = await axios.post(`https://api.rotiey.com/api/s/registration`, data, {
      headers,
    });
    if (response.data.status === true) {
      toast.success(response.data.message); // Toast success message
      return response.data; // Return response data
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};